function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("polygon", {
  fillRule: "evenodd",
  points: "1034.044 508.701 1036.809 502.69 1040.845 499.992 1052.914 499.992 1052.914 497.636 1057.933 496.124 1064.879 497.636 1075.586 499.249 1083.884 499.249 1090.258 501.661 1098.071 501.661 1102.691 508.071 1107.428 508.701 1115.905 511.377 1122.411 513.597 1127.839 524.62 1122.411 526.98 1113.978 526.98 1106.29 523.297 1104.067 521.809 1100.167 520.822 1099.274 525.287 1098.071 528.118 1090.258 524.62 1087.606 525.287 1086.422 530.425 1088.037 532.065 1086.422 533.894 1080.942 530.425 1075.586 526.98 1070.367 528.118 1069.065 526.98 1060.771 526.98 1056.887 523.297 1056.21 519.703 1052.065 518.904 1049.981 515.009 1047.295 511.377 1039.595 511.377",
  transform: "translate(-1034 -496)"
});

var SvgCaribbean = function SvgCaribbean(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    viewBox: "0 0 94 38",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCaribbean, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Caribbean.f692f1a6.svg";
export { ForwardRef as ReactComponent };